import React from 'react'

type IconProps = {
  size?: number
  color?: string
  className?: string
}

const ArrowRightIcon: React.FC<IconProps> = ({ size = '16', color = 'currentColor', ...attributes }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path d="M21.801 9.10579V10.8942L12.6952 20L11.4295 18.7406L19.2695 10.8942H0V9.10579H19.2695L11.4295 1.26574L12.6952 0L21.801 9.10579Z" fill={color} />
    </svg>
  )
}

export default ArrowRightIcon
